export default {"src":"/_next/static/media/crown.f8dcffe7.svg","height":436,"width":436,"blurWidth":0,"blurHeight":0};